<template>
    <header id="auth-header">
        <canvas class="particles-js-canvas-el" width="100%" height="100%"></canvas>
    </header>
</template>

<script>
    export default {
        name: "Particles",
        created() {
            particlesJS.load('auth-header', this.$root.publicURL + 'js/particles.json')
        }
    }
</script>

<style scoped>
    header#auth-header {
    /*background: #7C3155;*/
        background: #5B5A6B;
        border-top: solid 1px #ddd;
        border-bottom: solid 1px #ddd;
        height: 308px;
        width:100%;
        position:absolute;
        top:51px;
    }
</style>
